import {Component, DestroyRef, inject, OnDestroy, OnInit} from '@angular/core';
import {DbResponse} from "../../shared/interceptors/db-response";
import {NotifierComponent} from "../../shared/components/notifier/notifier.component";
import {Notification} from "../../shared/components/notifier/notification";
import {NotificationType} from "../../shared/components/notifier/notification-type";
import {PaymentMethod} from "../../user/payment-method";
import {Payment} from "../../user/payment";
import {ActivatedRoute} from '@angular/router';
import {UserService} from '../../user/user.service';
import {Utils} from "../../shared/utils/utils";
import {Product} from "../../websites/website/product";
import {UserSubscription} from "../../user/user-subscription";
import {DbDatePipe} from "../../shared/pipes/db-date.pipe";
import {WorkspaceService} from "../workspace.service";
import * as fromStore from "../../store";
import {filter, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {TypeUtils} from "../../shared/utils/type-utils";
import {Subject} from "rxjs/internal/Subject";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'db-payment-history',
    templateUrl: './payment-history.component.html',
    styleUrls: ['./payment-history.component.scss'],
    standalone: false
})
export class PaymentHistoryComponent implements OnInit, OnDestroy {

  public loading: boolean = true;
  public userSubscription: UserSubscription;
  public paymentMethods: PaymentMethod[];
  public payments: Payment[];
  public paymentPaypal: Payment[];
  public companyInfo: any;
  // pagination
  public currentPage: number = 1;
  public itemsPerPage: number = 20;
  public itemsCount: number = 0;
  public pagesCount: number = 0;
  private readonly _destroyStream$ = new Subject<boolean>();
  private readonly _destroyRef = inject(DestroyRef);

  constructor(
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _dbDatePipe: DbDatePipe,
    private _store: Store<fromStore.DbStoreState>,
    private _workspaceService: WorkspaceService
  ) {}

  ngOnInit() {
    this.payments = this._route.snapshot.data['payments'];
    !this.payments && this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getPayments)),
        takeUntil(this._destroyStream$)
      )
      .subscribe((payments) => {
        this.payments = payments;
        if  (this.payments) {
          this.payments = this.payments.filter((payment) => payment.paymentStatus !== 'requires_source_action');
          this.paymentPaypal = this.payments.filter((payment) => payment.paymentStatus !== 'requires_source_action' && !payment.cardType);
        }
      });

    this.userSubscription = this._route.snapshot.data['userSubscription'];
    this._getPaymentMethods();
    this._getCompanyInfo();
    this.setPaginationData();
  }

  private _getPaymentMethods(): void {
    let paymentMethods = null;
    this._store.select(fromStore.getUserPaymentMethodsLoaded)
      .pipe(
        switchMap(() => this._store.select(fromStore.getUserPaymentMethods))
      )
      .subscribe(data => {
        if (data && !TypeUtils.isNull(data)) {
          paymentMethods = Utils.sort(data, (a: Product, b: Product): number => {
            return a.active === b.active ? 0 : (b.active && !a.active ? 1 : -1);
          });
          this.paymentMethods = paymentMethods;
        }
        this.loading = false;
      });
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        takeUntil(this._destroyStream$)
      )
      .subscribe((companyInfo: any) => {
        this.companyInfo = companyInfo;
      });
  }

  private setPaginationData(): void {
    this.itemsCount = this.payments && this.payments.length;
    this.pagesCount = Math.ceil(this.itemsCount / this.itemsPerPage);
    this.currentPage = 1;
  }

  public onChangePage(page: number): void {
    this.currentPage = page;
  }

  downloadInvoice(payment: Payment): void {
    if (this.companyInfo?.payment_provider?.provider === 'paypal') {
      this._workspaceService.getPaymentInvoiceDownload(payment.id.toString())
        .pipe(
          filter(response => !!response),
          takeUntilDestroyed(this._destroyRef)
        )
        .subscribe(response => {
          if (response.success && response.data?.invoice_path) {
            window.open(response.data.invoice_path, '_blank');
          }
        });
    } else if (payment.invoicePath) {
      window.open(payment.invoicePath, '_blank');
    }
  }

  ngOnDestroy(): void {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}
